/* eslint-disable jira/naming/disallow-filenames */
import { useSelectedConfigTab } from '@jira/software__board-settings-rapidboard-config-common/src/useSelectedConfigTab.tsx';
import { useQueryParam } from '@atlassian/react-resource-router';

export const InsightsSettingsRedirect = (): null => {
	const { setSelectedConfigTab } = useSelectedConfigTab();
	const [, setConfigParam] = useQueryParam('config');
	setSelectedConfigTab('filter');
	setConfigParam('filter');

	return null;
};
